export function LoadingState() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="mission-panel p-6 text-center">
        <div className="holo-text font-mono text-xl mb-2">EXECUTIVE BRIEFING</div>
        <div className="text-green-400 font-mono text-sm">Loading dossier…</div>
      </div>
    </div>
  );
}